import { createSlice, nanoid, PayloadAction } from "@reduxjs/toolkit";
import type { IndicatorsState, IndicatorInstance, IndicatorName } from "./types";
import type { IndicatorSettings } from "./indicatorSettings";

const initialState: IndicatorsState = {
  instances: [],
  favorites: [],
};

const indicatorsSlice = createSlice({
  name: "indicators",
  initialState,
  reducers: {
    selectIndicator: (state, { payload }: PayloadAction<IndicatorName>) => {
      state.instances.push({ id: nanoid(), name: payload });
    },
    setIndicatorsInstances: (state, { payload }: PayloadAction<IndicatorInstance[]>) => {
      state.instances = payload;
    },
    removeIndicator: (state, { payload }: PayloadAction<string>) => {
      state.instances = state.instances.filter((i) => i.id !== payload);
    },
    resetIndicators: (state) => {
      state.instances = [];
    },
    updateIndicatorSettings: (
      state,
      { payload }: PayloadAction<{ id: string; settings: IndicatorSettings }>,
    ) => {
      const instance = state.instances.find((i) => i.id === payload.id);
      if (instance) instance.settings = payload.settings;
    },
    toggleIndicatorVisibility: (state, { payload }: PayloadAction<string>) => {
      const instance = state.instances.find((i) => i.id === payload);
      if (instance) instance.visible = instance.visible === false ? true : false;
    },
    toggleFavorite: (state, { payload }: PayloadAction<IndicatorName>) => {
      const idx = state.favorites.indexOf(payload);
      if (idx === -1) {
        state.favorites.push(payload);
      } else {
        state.favorites.splice(idx, 1);
      }
    },
    setFavoriteIndicators: (state, { payload }: PayloadAction<IndicatorName[]>) => {
      state.favorites = payload;
    },
  },
});

export const {
  selectIndicator,
  setIndicatorsInstances,
  removeIndicator,
  resetIndicators,
  updateIndicatorSettings,
  toggleIndicatorVisibility,
  toggleFavorite,
  setFavoriteIndicators,
} = indicatorsSlice.actions;

export default indicatorsSlice.reducer;
